import { lazy } from 'react';

export const StripeuserGroupPage = lazy(() => import('./page-list'));